import { styled, css } from '@mui/material/styles';
import { IconButton } from '@mui/material';

const DocumentButton = styled(IconButton)(
  ({ theme }) => css`
    margin-top: ${theme.spacing(1)};
    color: ${theme.palette.grey[500]};

    &:hover {
      background-color: transparent;
      color: ${theme.palette.secondary.main};
      transition: all 0.3s ease;
    }
    & > svg {
      height: 85px;
      width: 85px;
      fill: currentColor;
    }
  `,
);

export default DocumentButton;
